import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import T from '../theme';
import Icon from '../components/Icon';
import Reveal from '../components/Reveal';
import { PageHero, Btn, SectionWrap, FooterCTA } from '../components/shared';
import { SERVICES } from '../data';

const F = "'Plus Jakarta Sans', sans-serif";
const MONO = "'DM Mono', monospace";

function ServiceDetail({ svc, flip }) {
  const navigate = useNavigate();
 return (
 <Reveal variant="up">
 <div className="service-detail" style={{
 background: T.surface,
 border: `1.5px solid ${T.borderGray}`,
 borderRadius: 14, padding: '52px',
 display: 'grid', gridTemplateColumns: '1fr 1fr',
 gap: 64, alignItems: 'start',
 boxShadow: '0 2px 12px rgba(11,31,58,0.05)',
 }}>
 <div className="service-detail-main" style={{ order: flip ? 1 : 0 }}>
 <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
 <span style={{ fontFamily: MONO, fontSize: '0.72rem', color: T.slate }}>{svc.number}</span>
 <span style={{
 fontFamily: MONO, fontSize: '0.72rem', color: T.aquaDark,
 background: T.aquaGhost, border: `1px solid ${T.border}`,
 borderRadius: 4, padding: '3px 12px',
 }}>{svc.time}</span>
 </div>
 <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
 <Icon name={svc.icon} size={28} color={T.aqua} fill={1} />
 <h2 style={{ fontFamily: F, fontWeight: 800, fontSize: '2rem', letterSpacing: '-0.5px', color: T.ink }}>{svc.name}</h2>
 </div>
 <p style={{ fontFamily: MONO, fontSize: '0.8rem', color: T.aquaDark, marginBottom: 20 }}>{svc.tagline}</p>
 <p style={{ fontSize: '1rem', color: T.muted, lineHeight: 1.85, marginBottom: 32 }}>{svc.description}</p>
 <div style={{ display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
 <Btn onClick={() => { navigate('/contact'); window.scrollTo(0, 0); }}>{svc.cta} →</Btn>
 <span style={{ fontFamily: F, fontWeight: 800, fontSize: '1.5rem', color: T.aquaDark }}>{svc.price}</span>
 </div>
 </div>
 <div className="service-detail-deliverables" style={{ order: flip ? 0 : 1 }}>
 <div style={{ fontFamily: MONO, fontSize: '0.7rem', color: T.slate, textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 18 }}>
 What you get
 </div>
 {svc.deliverables.map((d, i) => (
 <div key={i} style={{
 display: 'flex', alignItems: 'flex-start', gap: 12,
 marginBottom: 10, padding: '14px 16px',
 background: T.surfaceAlt,
 border: `1px solid ${T.borderGray}`, borderRadius: 8,
 }}>
 <Icon name="check_circle" size={18} color={T.aqua} fill={1} style={{ flexShrink: 0, marginTop: 1 }} />
 <span style={{ fontSize: '0.95rem', color: T.inkMid, lineHeight: 1.6 }}>{d}</span>
 </div>
 ))}
 </div>
 </div>
 </Reveal>
 );
}

export default function Services() {
 return (
 <div style={{ background: T.bg }}>
 <PageHero
 
 title={<>Productised UX packages.<br /><span style={{ color: T.aquaDark }}>Fixed price. Clear outcomes.</span></>}
 sub="No retainer traps, no scope creep. Every package has a defined deliverable, timeline, and price — so you know exactly what you're getting."
 />
 <SectionWrap>
 <div style={{ display: 'grid', gap: 28 }}>
 {SERVICES.map((svc, i) => (
 <ServiceDetail key={svc.id} svc={svc} flip={i % 2 !== 0} />
 ))}
 </div>
 </SectionWrap>
 <FooterCTA />
 </div>
 );
}